import React from "react";
import { IUserTypes } from "../../../types/contacts";
import ChatUser from "../Chats/ChatUser";

interface DirectMessagesProps {
  title: string;
  users: IUserTypes[];
  openAddContact: () => void;
  selectedChatId: number;
  onSelectChat: (id: number) => void;
}

const RobotMessagesComponent = ({
  title,
  users,
  openAddContact,
  selectedChatId,
  onSelectChat
}: DirectMessagesProps) => {

  // console.log("RENDER RobotMessages", title);

  return (
    <>
      <div className="d-flex align-items-center px-4 mt-3 mb-2">
        <div className="flex-grow-1">
          <h4 className="mb-0 font-size-14 text-muted text-uppercase">
            {title} ({users.length})
          </h4>
        </div>
      </div>

      <div className="chat-message-list">
        <ul className="list-unstyled chat-list chat-user-list">
          {users?.map((user) => (
            <ChatUser
              key={user.id}
              user={user}
              selectedChat={selectedChatId}
              unreadCount={user.unreadCount}
              onSelectChat={onSelectChat}
            />
          ))}
        </ul>
      </div>
    </>
  );
};

// 🔥 MEMO COM COMPARAÇÃO INTELIGENTE
const RobotMessages = React.memo(
  RobotMessagesComponent,
  (prev, next) => {
    // 🔹 mesmo título
    if (prev.title !== next.title) return false;

    // 🔹 mesmo chat selecionado
    if (prev.selectedChatId !== next.selectedChatId) return false;

    // 🔹 tamanho diferente → mudou
    if (prev.users.length !== next.users.length) return false;

    // 🔥 comparação leve (não deep)
    for (let i = 0; i < prev.users.length; i++) {
      const prevUser = prev.users[i];
      const nextUser = next.users[i];

      if (
        prevUser.id !== nextUser.id ||
        prevUser.unreadCount !== nextUser.unreadCount ||
        prevUser.lastMessageTime !== nextUser.lastMessageTime
      ) {
        return false; // 🔥 re-render necessário
      }
    }

    return true; // 🔥 evita re-render
  }
);

export default RobotMessages;